import React from "react";

export default function TituloTexto({ titulo, texto }) {
  return (
    <section className="bg-sidom-blue  h-[400px] p-6">
      <div className="flex flex-col items-center justify-center h-full">
        <h1 className="text-sidom-orange text-xl sm:text-2xl md:text-3xl lg:text-4x1 leading-6  font-bold mb-2">
          {titulo}
        </h1>
        <p className="text-sidom-light text-sm md:text-base">{texto}</p>
      </div>
    </section>
  );
}
